export const DEVTOOLS_MESSAGE_IDENTIFIER = '__ems-devtools__';
export const DEVTOOLS_HOOK_IDENTIFIER = '__EMS_DEVTOOLS_HOOK__';
export const DEVTOOLS_PING_INTERVAL = 10000;
export const DEVTOOLS_LOCAL_STORAGE_KEY = 'enableEMSDevtools';